import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchLostProjects = createAsyncThunk(
  'lostProjects/fetchLostProjects',
  async ({ userUID}, { rejectWithValue }) => {
    try {
      if (!userUID) {
        return rejectWithValue("User UID is missing");
      }
      const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/lostClients/${userUID}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
    }
  }
);

const lostProjectsReducer = createSlice({
  name: 'lostProjects',
  initialState: {
    data: { clients: [], currentPage: 1, hasNextPage: false, totalPages: 1 },
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLostProjects.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLostProjects.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchLostProjects.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default lostProjectsReducer.reducer;
